import { ConfigService } from './config.service';
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { SnackbarService } from './snackbar.service';
import { SpinnerngxService } from '../spinnerngx/spinnerngx.service';

@Injectable({
    providedIn: 'root'
})

export class AppErrorHandler implements ErrorHandler {
    private configService: ConfigService;
    private router: Router;
    constructor(
        private injector: Injector,
        private ngZone: NgZone,
        private snackBarService: SnackbarService,
        private spinnerngxService: SpinnerngxService
    ) {
    }
    // tslint:disable-next-line:use-lifecycle-interface

    ngOnInit() {
    }

    public ErrorsApi(error: any): string {
        let serverError;
        let defaultError: boolean = false;
        this.configService = this.injector.get(ConfigService);
        this.router = this.injector.get(Router);
        if (!navigator.onLine) {
            serverError = "Error de conexión"
        }
        else {
            switch (error.status) {
                case 0:
                    serverError = this.configService.mensajes.Error0;
                    break;
                case 401:
                    serverError = this.configService.mensajes.Error401;
                    this.router.navigateByUrl('/', { skipLocationChange: true })
                        .then(() => {
                            location.reload();
                            this.router.navigate(['/login'])
                        }
                        );
                    break;
                case 403:
                    serverError = this.configService.mensajes.Error403;
                    this.router.navigate(['/home'])
                    /* this.router.navigateByUrl('/', {skipLocationChange: true})
                     .then(()=>
                       {                     
                         location.reload();
                         this.router.navigate(['/home'])
                       }
                     );        */
                    break;
                case 404:
                    serverError = this.configService.mensajes.Error404;
                    break;
                case 500:
                    //serverError = error.headers ? error.headers.get('Application-Error') : this.configService.mensajes.Error500;
                    serverError = this.configService.mensajes.Error500 + " " + error.statusText;
                    break;
                default:
                    serverError = error.statusText;
                    if (typeof error.error != 'undefined') {
                        console.log(error.error);
                        serverError = "Error " + error.status + ": " + error.message;
                    }
                    defaultError = true;
                    break;
            }
        }
        let modelStateErrors = '';
        /*const applicationError = error.headers.get('Application-Error');
        if (error.status === 400 ) {
            if (applicationError == null) {
                        serverError = error;
                            for (const key in serverError.error) {
                                if ( serverError.error[key] ) {
                                    modelStateErrors +=  (serverError.error[key] + '<br/>').replace(/,/g, '');
                                }
                            }
            }
        }*/

        let errorHTML: boolean = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/.test(error.error);

        var apiError = '';

        if (errorHTML) {
            apiError = typeof (error.name) === 'string' ? error.name + ": " + error.status + " " + error.statusText : '';
            console.log(error.message)
        }
        else {
            apiError = typeof (error.error) === 'string' ? error.error : '';
        }

        const apiGeneralError = ((error.error != null) && (error.error.Message != null)) ? error.error.Message : '';
        const bodyError = typeof (error._body) === 'string' ? error._body : '';
        const msg = apiGeneralError || apiError || serverError || bodyError
        return msg
    }

    handleError(error: any) {
        this.ngZone.run(
            () => {
                this.router = this.injector.get(Router);
                let msg = this.ErrorsApi(error)
                if (msg != 'undefined' && msg != null && msg != '') {
                    if (this.configService.etiquetas.KeyWordsErrorSnackbar.find(a => msg.includes(a))) {
                        if (msg.includes("Intentos")) {
                            this.snackBarService.openSnackbar("Clave Incorrecta", msg, 0, 1)
                        }
                        if (msg.includes("verificada")) {
                            this.snackBarService.openSnackbar("Cuenta No Verificada", msg, 2, 1)
                        }
                        if (msg.includes("bloqueado")) {
                            this.snackBarService.openSnackbar("Cuenta Bloqueada", msg, 0, 1)
                        }
                    }
                    else {
                        this.snackBarService.openSnackbar("Error", msg, 0, 1)
                    }
                }
            }
        );
    }
}
